module.exports = __webpack_public_path__ + "static/media/minigelatinas2.d7f8c443.jpg";